import { render, staticRenderFns } from "./must-label.vue?vue&type=template&id=5c06ff50&scoped=true"
import script from "./must-label.vue?vue&type=script&lang=js"
export * from "./must-label.vue?vue&type=script&lang=js"
import style0 from "./must-label.vue?vue&type=style&index=0&id=5c06ff50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06ff50",
  null
  
)

export default component.exports